/**
 * @typedef {'string'|'number'|'int'|'integer'|'float'|'double'|'date'|'datetime'} HeaderType
 */
/**
 *
 * @typedef {Object} ExportData
 * @property {Object<string, { title: string, type?: HeaderType }>} headers
 * @property {Array<object>} rows
 *   Data rows to export. Values are pre-formatted for export.
 * @property {string} fileName
 *   Optional base file name for the export (without extension).
 */
/**
 * Creates a form that triggers a POST request in another tab and it will download a file
 * 
 * @param {ExportData} data 
 */
export function downloadXlsx(data) {
    const url = window.wisenetwork.REST_URL + '/adminexcelexport/'
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = '_blank';

    Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = typeof value === 'string' ? value : JSON.stringify(value);
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    form.remove();
}